// hooks/useUniversalAuth.js - FLUTTER-PROOF VERSION
export const useUniversalAuth = () => {
  const checkToken = () => {
    // 1️⃣ Android WebView
    if (typeof window.Android !== 'undefined') {
      return window.Android.getToken?.() || null;
    }
    
    // 2️⃣ Flutter WebView fallback (your token in URL)
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get('token');
    
    // 3️⃣ localStorage (web + Flutter shared_prefs sync)
    const storageToken = localStorage.getItem('token');
    
    // ✅ PRIORITY: URL > localStorage
    return urlToken || storageToken || null;
  };

  const setToken = (token) => {
    localStorage.setItem('token', token);
    
    // Optional: Notify Android only
    if (typeof window.Android !== 'undefined') {
      window.Android.onLoginSuccess?.(token);
    }
  };

  const clearToken = () => {
    localStorage.removeItem('token');
    if (typeof window.Android !== 'undefined') {
      window.Android.onLogout?.();
    }
  };

  return { checkToken, setToken, clearToken };
};
